export default __webpack_public_path__ + "static/media/bell-icon.383fc953.svg";